import type { User } from '#auth-utils'
import { toValue } from 'vue'

type MaybeUser = MaybeRefOrGetter<User | undefined | null>

export function isTeacher(user: MaybeUser) {
  return toValue(user)?.role?.includes('teacher') ?? false
}

export function isConsumer(user: MaybeUser) {
  return toValue(user)?.source === 'VIPPS'
}

export function canUseCart(user: MaybeUser) {
  return isConsumer(user) || isTeacher(user)
}
